import { combineReducers } from 'redux';

import simpleAverageReport from './simpleaverage/reducer';

export default combineReducers({
  simpleAverageReport,
});



// WEBPACK FOOTER //
// ./src/pages/simpleaverage/state/reducer.js